<template>
  <div id="app">
    <router-view></router-view>

    <div style="position:fixed;width:40px;height:40px;right:150px;bottom:100px;z-index:4;cursor:pointer;opacity: 0.8;" v-if="show" @click="toTop">
      <div
        style="{
          height: 100%;
          width: 100%;
          box-shadow: 0 0 6px rgba(0,0,0, .12);
          text-align: center;
        }"
      >
        <img src="/pc/static/img/hom/top.png" alt="" style="width: 100%;display:block;">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      show: false
    }
  },
  methods: {
    toTop () {
      document
        .querySelector('body')
        .scrollIntoView({ block: 'start', behavior: 'smooth' })
      this.show = false
    }
  },
  mounted () {
    window.addEventListener('scroll', () => {
      let scrollt = document.documentElement.scrollTop + document.body.scrollTop
      if (scrollt > 200) {
        this.show = true
      }
      if (scrollt === 0) {
        this.show = false
      }
    })
    console.log('rebuild')
    function detectIE () {
      var ua = window.navigator.userAgent

      var msie = ua.indexOf('MSIE ')
      if (msie > 0) {
        return true
      }

      var trident = ua.indexOf('Trident/')
      if (trident > 0) {
        return true
      }

      var edge = ua.indexOf('Edge/')
      if (edge > 0) {
        return true
      }

      return false
    }

    if (!!window.ActiveXObject || 'ActiveXObject' in window || detectIE()) {
      window.addEventListener('hashchange', () => {
        let currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
  }
  // async beforeRouteEnter (next) {
  //   this.$axios.defaults.baseURL = process.env.VUE_APP_AXIOS_o
  //   await this.$axios.get('/api/ip.php').then(res => {
  //     console.log(res)
  //   })
  //   next()
  // }
}
</script>

<style>
a {
  text-decoration: none;
  color: #fff;
}
.center {
  text-align: center;
}
body {
  color: #fff;
}
@media only screen and (max-width: 1460px) {
  @media screen and (-webkit-min-device-pixel-ratio:0) {
    body {
      /*zoom: 0.8;*/
    }
  }
}
html, body {
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 100%;
}
#app {
  /* padding-top: 60px; */
  /* overflow: auto; */
}

.el-dropdown-menu.el-popper {
  margin-top: 0px;
}

.right-float {
  float: right;
}

div:focus {
  outline: none;
}
video:focus {
  outline: none;
}
img {
  border-style:none;
  border: 0;
}

.swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled {
  pointer-events: inherit!important;
}

.home-color {
  color: #ffffff;
}
.home-p-color {
  background-color: transparent;
}
.bg-color {
  /* background: #e2e2e2; */
  background: #5a0814;
}
.bg-p-color {
  color: #828282;
}

/* element样式 */
.el-tabs__item:focus.is-active.is-focus:not(:active) {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.el-popover.el-popper:focus {
  outline: none;
}
.el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus, .el-message-box__input input.invalid, .el-message-box__input input.invalid:focus {
  border-color: #cc7272!important;
}
</style>
